import GlobalController from '../base-controllers/GlobalController';

import { getData, selectAll } from '../utils/dom';

const JS_ATTR_DATA_ATTR = 'js-attr';

/**
 * Controller for setting attributes with JavaScript.
 *
 * Works on any element.
 *
 * @example
 *
 * <div data-js-attr='{"role": "tabpanel", "tabindex": "0"}'>Text</div>
 */
export default class JSAttr extends GlobalController {
  static id = 'JSAttr';

  init() {
    this.replaceAttributes();
  }

  /**
   * Add attributes to elements that are only useful or relevant
   * when JS is available.
   */
  replaceAttributes() {
    selectAll(`[data-${JS_ATTR_DATA_ATTR}]`).forEach((el) => {
      const attrs = getData(el, JS_ATTR_DATA_ATTR, JSON.parse) || {};
      Object.entries(attrs).forEach(([key, val]) => {
        el.setAttribute(key, val);
      });
    });
  }
}
